import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getDashboardDataAPI } from "../api/DashboardApi";
import { userActivityAllAPI, userActivityBySearchKeywordAPI, userActivityJobCategoriesSummaryAPI, userActivityLocationSummaryAPI, userActivitySearchSummaryAPI } from "../api/UserAnalyticsApi";

const initialState = {
  dashboardData: null,
  visitors: [],
  userActivities: {},
  keywordSummury: [],
  locationSummary: [],
  jobCategoriesSummary: [],
  value: 0,
  paginations: {
    "size": 10,
    "number": 0,
    "totalElements": 0,
    "totalPages": 0
  },
  loading: false,
};

export const getDashboardData = createAsyncThunk(
  "dashboard/getDashboardData",
  async (rejectWithValue) => {
    try {
      const response = await getDashboardDataAPI();
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const userActivityAll = createAsyncThunk(
  "dashboard/userActivityAll",
  async (payload, {rejectWithValue}) => {
    try {
      const response = await userActivityAllAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const userActivityBySearchKeyword = createAsyncThunk(
  "dashboard/userActivityBySearchKeyword",
  async (payload, {rejectWithValue}) => {
    try {
      const response = await userActivityBySearchKeywordAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const userActivitySearchSummary = createAsyncThunk(
  "dashboard/userActivitySearchSummary",
  async (payload, {rejectWithValue}) => {
    try {
      const response = await userActivitySearchSummaryAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const userActivityLocationSummary = createAsyncThunk(
  "dashboard/userActivityLocationSummary",
  async (payload, {rejectWithValue}) => {
    try {
      const response = await userActivityLocationSummaryAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const userActivityJobCategoriesSummary = createAsyncThunk(
  "dashboard/userActivityJobCategoriesSummary",
  async (payload, {rejectWithValue}) => {
    try {
      const response = await userActivityJobCategoriesSummaryAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setTabValue: (state, action) => {
      state.value = action.payload;
    }
  },
  extraReducers: (builder) => {
    
    //GET user Activity All
    builder.addCase(userActivityAll.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(userActivityAll.fulfilled, (state, action) => {
      state.userActivities = action.payload?.response;
      state.visitors = action.payload?.response?.userList?.content;
      state.paginations = action.payload?.response?.userList?.page;
      state.loading = false;
    });
    builder.addCase(userActivityAll.rejected, (state) => {
      state.loading = false;
    });

    //GET user keyword Activity
    builder.addCase(userActivityBySearchKeyword.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(userActivityBySearchKeyword.fulfilled, (state, action) => {
      // state.userActivities = action.payload?.response;
      // state.visitors = action.payload?.response?.userList?.content;
      state.loading = false;
    });
    builder.addCase(userActivityBySearchKeyword.rejected, (state) => {
      state.loading = false;
    });

    //GET userActivitySearchSummary
    builder.addCase(userActivitySearchSummary.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(userActivitySearchSummary.fulfilled, (state, action) => {
      // state.userActivities = action.payload?.response;
      state.keywordSummury = action.payload?.response?.content;
      state.paginations = action.payload?.response?.page;
      state.loading = false;
    });
    builder.addCase(userActivitySearchSummary.rejected, (state) => {
      state.loading = false;
    });

    //GET userActivityLocationSummary
    builder.addCase(userActivityLocationSummary.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(userActivityLocationSummary.fulfilled, (state, action) => {
      // state.userActivities = action.payload?.response;
      state.locationSummary = action.payload?.response?.content;
      state.paginations = action.payload?.response?.page;
      state.loading = false;
    });
    builder.addCase(userActivityLocationSummary.rejected, (state) => {
      state.loading = false;
    });

    //GET userActivityJobCategoriesSummary
    builder.addCase(userActivityJobCategoriesSummary.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(userActivityJobCategoriesSummary.fulfilled, (state, action) => {
      // state.userActivities = action.payload?.response;
      state.jobCategoriesSummary = action.payload?.response?.content;
      state.paginations = action.payload?.response?.page;
      state.loading = false;
    });
    builder.addCase(userActivityJobCategoriesSummary.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const { setTabValue } = dashboardSlice.actions;
export default dashboardSlice.reducer;
